module.exports = __webpack_public_path__ + "media/images/drag-handle-a388c1e0a44ee0c51989945f05258050.png";